import { render } from "./AlertsComponent.vue?vue&type=template&id=236a7cff"
import script from "./AlertsComponent.vue?vue&type=script&lang=js"
export * from "./AlertsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__